import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { connect } from 'react-redux';
import { TariffTile } from '@beef/smart-kit';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { getFallbackBannerCard } from "../../../../store/blocks/checkAddress/selectors";
import styles from "../../../../styles.pcss";
var cn = classNames.bind(styles);
export var _FallbackBanner = function _FallbackBanner(_ref) {
  var className = _ref.className,
    tariffData = _ref.tariffData;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('component', className),
    "data-t-id": "components-FallbackBanner"
  }, /*#__PURE__*/React.createElement(TariffTile, _extends({}, tariffData, {
    buttonClassName: cn('tariffButtonClass'),
    footerColor: "white"
  })));
};
_FallbackBanner.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  tariffData: PropTypes.arrayOf(PropTypes.shape({}))
} : {};
var mapStateToProps = function mapStateToProps(state) {
  return {
    tariffData: getFallbackBannerCard(state)
  };
};
export var FallbackBanner = connect(mapStateToProps)(_FallbackBanner);